import { gql } from "@apollo/client";

export const GET_CONEXIONES_PENDIENTE_FACTURAR = gql`
    query GetConexionesPendienteFacturar($filter: MinutaFilterInput!) {
    conexionesPendienteFacturar(filter: $filter) {
        idEvaluacion,
        idPaciente,
        paciente,
        codPacienteSAP,
        codClienteSAP,
        cliente,
        modulo,
        tipoModulo,
        cantidadConexion,
        precioDiario,
        precioSAP,
        precioTotal,
        fechaDesdeMin,
        fechaHastaMax,
        observaciones,
        idPlanCuidado,
        codPlanSAP
    }
}
`;

export const adaptConexionesPendienteFacturar = (conexion) => {
  return {
    idEvaluacion: conexion?.idEvaluacion,
    idPaciente: conexion?.idPaciente,
    paciente: conexion?.paciente,
    codPacienteSAP: conexion?.codPacienteSAP,
    codClienteSAP: conexion?.codClienteSAP,
    cliente: conexion?.cliente,
    modulo: conexion?.modulo,
    tipoModulo: conexion?.tipoModulo,
    cantidadConexion: conexion?.cantidadConexion,
    precioDiario: conexion?.precioDiario,
    precioSAP: conexion?.precioSAP,
    precioTotal: conexion?.precioTotal,
    fechaDesdeMin: conexion?.fechaDesdeMin,
    fechaHastaMax: conexion?.fechaHastaMax,
    observaciones: conexion?.observaciones,
    idPlanCuidado: conexion?.idPlanCuidado,
    codPlanSAP: conexion?.codPlanSAP
  };
};

export const adaptConexionesPendienteFacturarArray = (conexiones) => {
  return structuredClone(conexiones)?.
  map((conexion) => adaptConexionesPendienteFacturar(conexion));
};